import React from 'react';
import Header from './Header';
import Navbar from './Navbar';
import Ticker from './Ticker';
import Footer from './Footer';

const Layout = ({ children }) => {
    return (
        <>
            <Header />
            <Ticker />
            <Navbar />
            <main>{children}</main>
            <Footer />
        </>
    );
};

export default Layout;